// AUTH getters
export default {
  get_show_app_views: (state) => state.showAppViews,
  get_is_authed: (state) => state.token !== '',
  get_is_logged: (state) => state.userLogged,
  get_is_admin: (state) => state.info.is_admin,
  get_is_ship365: (state) => (parseInt(state.info.backoffice_id, 10) === 1),
  get_user: (state) => state.info,
  get_subaccounts: (state) => state.subaccounts,
  get_active_subaccount: (state) => state.activeSubaccount,
  get_allowed_subaccounts_select_options: (state) => state.subaccounts.filter((acc) => state.info.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({ text: acc.name, value: String(acc.id) }))
};
